const debtor = {
	discounts: {
		title: "Ermäßigungen",
	},

	/* ----------------------------- DOMAIN SETTINGS ---------------------------- */
	domain_settings: {
		description: `Dies sind Alles-oder-Nichts-Einstellungen. Also ein Name ist nicht und ein anderer Domainname ist, funktioniert nicht.
			Der Kunde hat seine eigenen Nameserver? Dann kann er seine DNS nicht im Portal verwalten.
			Der Kunde möchte unsere Nameserver mit seinem eigenen Namen verwenden?
			
			Informieren Sie einen Techniker, dass Sie dies tun werden und teilen Sie ihm die Namen mit (z.B. n1.kundenname.com und ns2.kundenname.com. Kundenname.com muss bei uns sein!)
			Erstellen Sie eine Nameservergruppe in OXXA mit diesen Namen
			Warten Sie auf die Genehmigung des Ingenieurs.
			Fügen Sie dann diese Nameservergruppe in Portal hinzu und verknüpfen Sie sie mit dem Schuldner.

			Wenn Sie nichts einstellen, dann werden standardmäßig die Nameserver von Tuxis verwendet, was auch die gewünschte Einstellung ist.
			Wenn Sie diese Einstellung zwischendurch ändern, gilt sie für alle neuen Registrierungen. Alte Registrierungen werden nicht geändert.
			Mit OXXA können Sie also auch eine Nameservergruppe löschen.`,
		nameserver_group: {
			title: "Benutzerdefinierte Nameservergruppe",
		},
		title: "Domaineinstellungen",
	},
	information: {
		description: "",
		title: "Informationen zum Schuldner",
	},
	notes: {
		description: "Hier gibt es interne Vermerke, die der Schuldner nicht sehen kann.",
		messages: {
			success: "Interne Notiz erfolgreich aktualisiert!",
		},
		title: "Schuldner von Schuldverschreibungen",
	},
	products: {
		domain: "Domainnamen",
		pbs: "Tuxis PBS",
		vps: "VPSs",
	},

	/* ------------------------------ SETTINGS PAGE ----------------------------- */
	settings: {
		block_debtor: {
			block_button: "Schuldner sperren",
			blocked: "Blockiert",
			deblock_button: "Schuldner entsperren",
			description: "",
			title: "Schuldner sperren/entsperren",
		},
		block_dialog:
			"Sind Sie sicher, dass Sie den Schuldner <strong>{{debtor_code}}</strong> sperren wollen?",
		description: "",
		messages: {
			success: "Einstellung geändert!",
		},
		never_invoice: {
			description: "Stellen Sie diesem Schuldner niemals eine Rechnung aus.",
			label: "Niemals Rechnung",
		},
		paid_services_disabled: {
			description: "Bezahlte Dienste ausschließen",
			label: "Bezahlte Dienstleistungen",
		},
		status: {
			successful_block: "Schuldner erfolgreich gesperrt",
			successful_unblock: "Schuldner erfolgreich entsperrt",
		},
		title: "Einstellungen des Schuldners",
		unblock_dialog:
			"Sind Sie sicher, dass Sie den Schuldner <strong>{{debtor_code}}</strong> entsperren wollen?",
		vies: {
			button: "VIES-Protokoll anzeigen",
			description: "",
			title: "VIES-API Ergebnisse",
		},
	},
	status: {
		create: "Der Schuldner wurde erfolgreich hinzugefügt!",
		update: "Der Schuldner wurde erfolgreich geändert!",
	},
	tabs: {
		discounts: "Ermäßigungen",
		information: "Informationen",
		invoices: "Rechnungen",
		notes: "Anmerkungen",
		orders: "Bestellungen",
		passwords: "Gemeinsame Passwörter",
		products: "Produkte",
		relations: "Beziehungen",
		settings: "Einstellungen",
		users: "Benutzer",
	},
	title: "Schuldner",
};

export default debtor;
